import { render, staticRenderFns } from "./mainVideo.vue?vue&type=template&id=a565fa2c&scoped=true"
import script from "./mainVideo.vue?vue&type=script&lang=js"
export * from "./mainVideo.vue?vue&type=script&lang=js"
import style0 from "./mainVideo.vue?vue&type=style&index=0&id=a565fa2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a565fa2c",
  null
  
)

export default component.exports